import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useDarkMode from "use-dark-mode";

import i18n from "i18next";
import { GetUrlPath } from "Utility/hooks/url";

import { setTimeZone, setIsDarkMode } from "Components/store/globalSlice";
import { useAppDispatch, useAppSelector } from "store/hook";

// PreferenceProps，描述了 usePreference hook 所需的 prop 屬性，
// 包括語言、工單語言、深色模式、使用者等級、時區和登錄狀態。
interface PreferenceProps {
  language: string;
  ticket_language: string;
  dark_mode: boolean;
  level: string;
  time_zone: string;
  isLogin: boolean;
}

//usePreference hook：usePreference 函數接受一個物件作為參數，該物件包含使用者的各種偏好設定。
export const usePreference = ({ language, ticket_language, dark_mode, level, time_zone, isLogin }: PreferenceProps) => {
  // 使用 useDarkMode hook 創建了一個與深色模式相關聯的狀態和方法。
  const darkMode = useDarkMode(dark_mode);
  // 獲取了 useAppDispatch  的實例，用於在 Redux store 中發送 action 。
  const disp = useAppDispatch();
  const navigate = useNavigate();
  const urlPath = GetUrlPath();

  // 當語言屬性變化時，調用 i18n.changeLanguage 方法來改變應用程式的語言。
  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  // 用 useEffect 鈎子，當深色模式屬性變化時，根據新的深色模式狀態啟用或禁用深色模式。
  useEffect(() => {
    if (dark_mode) {
      darkMode.enable();
    } else {
      darkMode.disable();
    }
    // 使用 Redux 的 setIsDarkMode action 更新全域狀態中的深色模式設定。
    disp(setIsDarkMode(dark_mode));
  }, [dark_mode]);

  // 當時區屬性變化時，使用 Redux 的 setTimeZone action 更新全域狀態中的時區設定。
  useEffect(() => {
    disp(setTimeZone(time_zone));
  }, [time_zone]);
};
